import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user.js'
import property from './modules/property.js'
import building from './modules/building.js'
import search from './modules/search.js'
import general from './modules/general.js'

Vue.use(Vuex)

// const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    user,
    property,
    building,
    search,
    general
  },
})